import { Component, effect, ChangeDetectionStrategy } from '@angular/core'
import { ProductDepot } from 'depoto-core/src/entities'
import { CoreService } from '../../../services'
import { ProductDetailService } from '../../../product-detail.service'
import { Router } from '@angular/router'
import { FmtDatePipe } from '../../../pipes'

@Component({
  selector: 'product-depots-form',
  templateUrl: './product-depots-form.component.html',
  styles: [
    `
      .quantityStock {
        color: #000;
      }
      .quantityReservation {
        color: #e8261e;
      }
      .quantityAvailable {
        color: #086e11;
      }
    `,
  ],
  styleUrls: ['product-depots-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProductDepotsFormComponent {
  isShowingNullStock = false
  // Guards template to wait until essential data (product + depots options) are available
  isInitialDataLoading = true
  private didInitialResolve = false

  constructor(
    private core: CoreService,
    public productDetailService: ProductDetailService,
    public router: Router
  ) {
    effect(() => {
      this.productDetailService.queryCarriers.data()
      this.productDetailService.queryCurrencies.data()
      this.productDetailService.queryPayments.data()
      this.productDetailService.queryProducers.data()
      this.productDetailService.queryDepotsOptions.data()
      this.productDetailService.queryVats.data()
      this.productDetailService.querySuppliers.data()
    })

    // Ensure stock is resolved only after required data are ready
    effect(() => {
      const depots = this.productDetailService.queryDepotsOptions.data()
      const product = this.productDetailService.product

      // Wait until a product exists and depots options have resolved (data() is not undefined)
      const ready = !!product && typeof depots !== 'undefined'
      if (ready && !this.didInitialResolve) {
        this.didInitialResolve = true
        this.isInitialDataLoading = false
        this.productDetailService.resolveStock()
      } else if (ready) {
        this.isInitialDataLoading = false
      }
    })
  }

  public modalStockResult(pDepot?, productMovePack = null, type: 'in' | 'out' | 'edit' = 'edit') {
    if (type === 'in' || type === 'out') {
      this.productDetailService.refreshProduct()
      return
    }

    if (type === 'edit') {
      // Update the existing object reference so Angular template reflects changes
      // Reassigning the parameter (pDepot = ...) only changes the local variable
      // and does not update the object used by the template.
      const updated = new ProductDepot(productMovePack)
      Object.assign(pDepot, updated)
    }
    this.productDetailService.resolveStock()
  }

  areJustNullQuantitiesInTable(stockItem) {
    // filter all productDepots with quantityStock or quantityReservation - if there aren't any -> show no items text
    return !!stockItem.productDepots.every(pDepot => {
      return (
        (!pDepot.quantityStock || pDepot.quantityStock <= 0) &&
        (!pDepot.quantityReservation || pDepot.quantityReservation <= 0)
      )
    })
  }

  printQR(depot: ProductDepot) {
    const filterPipe = new FmtDatePipe()
    window['dataQR'] = {
      ean: this.productDetailService.product.ean || '',
      batch: depot.batch || '',
      expirationDate: filterPipe.transform(depot.expirationDate, 'yyyy-MM-dd') || '',
    }
    this.router.navigate(['/product', this.productDetailService.product.id, 'print'])
  }

  refreshDepotStats() {
    this.core.services.product.refreshProductDepots(this.productDetailService.product.id).then(() => {
      this.productDetailService.refreshProduct()
    })
  }

  trackByFn(index: any) {
    return index
  }
}
